var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.31 116.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,58.1A34.16,34.16,0,1,1,61.1,92.27,34.15,34.15,0,0,1,27,58.1ZM70.14,39c-2.67.07-5.3,0-7.89.25a6.49,6.49,0,0,0-5.44,3.91,9.34,9.34,0,0,0-.88,4.06v3.54c-1.11,0-2.15,0-3.19,0-.54,0-.72.12-.71.68,0,2.19,0,4.37,0,6.55a5.71,5.71,0,0,0,.06.63H56V78h7.79V58.57h5.76c.24-2.63.48-5.18.72-7.83h-6.2c0-1,0-1.87,0-2.76,0-1.7.53-2.21,2.24-2.21h3.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/FACEBOOK.f02a41e52b72f455acca740cae78cc9a.svg";
export { ForwardRef as ReactComponent };